import {ServiceBase} from '../ServiceBase';
import {IMarketingService} from './marketing.service.interface';
import {Check} from '@sparkware/app-utils';
import {encodeUriRecursive} from '../../../utils/url-utils';
import {MarketingParams} from "../../../common/interfaces/marketing-params.interface";


const TEST_DATA_KEY = 'testdata';

export class MarketingService extends ServiceBase implements IMarketingService {

  private get _sCut(): any {
    return this.services.window.getGlobalProperty('sCut');
  }

  private get _sCutQueryParams(): string | null {
    let sCut = this._sCut;
    if(sCut) {
      return sCut.toString();
    } else {
      return null;
    }
  }

  appendSCutToUrl(url: string): string {
    if(!url) {
      return url;
    }

    if(!this._sCutQueryParams) {
      return url;
    }

    let urlParts = url.split('?');
    let queryParams = (urlParts[1] || '').trim();
    if(queryParams) {
      if(queryParams.endsWith('&')) {
        return urlParts[0] + '?' + queryParams + this._sCutQueryParams;
      } else {
        return urlParts[0] + '?' + queryParams + '&' + this._sCutQueryParams;
      }
    } else {
      return urlParts[0] + '?' + this._sCutQueryParams;
    }
  }

  private _getDlp(): string {
    return this.services.location.currentUri.getUrlWithoutSearchAndHash();
  }

  private _convertParameterToNumber(parameterName: string, parameterValue): number {
    let dlAsNumber = parseInt((parameterValue || '').trim());
    if(Check.isNumber(dlAsNumber)) {
      return dlAsNumber;
    } else {
      this.services.logger.error(`Cannot convert marketing parameter ${parameterName} to number because its value is ${parameterValue}`);
      return 999999;
    }
  }

  getMarketingData(marketingParams?: MarketingParams): any {
    let sCut = this._sCut;
    if(!Check.isObject(sCut)) {
      return {};
    }

    if(!sCut["all"]) {
      this.services.logger.warning(`sCut.all function doesn't exists`);
      return {};
    }

    let sCutData = sCut["all"]();

    if(!sCutData) {
      this.services.logger.warning(`sCut.all() returned ${sCutData}`);
      return {};
    }

    marketingParams = marketingParams || {};

    let additionalParams: any = {...sCutData};
    delete additionalParams[TEST_DATA_KEY];
    if(!additionalParams.wtc && marketingParams.wtc) {
      additionalParams.wtc = marketingParams.wtc;
    }


    let testData: any = {};

    try {
      testData = sCutData[TEST_DATA_KEY] ? JSON.parse(sCutData[TEST_DATA_KEY]) : {}
    } catch (err) {
      this.services.logger.error('Failed to parse sCut TestData');
      return {};
    }

    if(!testData.dl && marketingParams.dl) {
      testData.dl = marketingParams.dl;
    }

    if(testData.dl) {
      //We try to convert the dl to number to see if it is a valid number
      //but we must send it as a string because  membership code will throw error on GetFunnelData if it will be number
      testData.dl = (this._convertParameterToNumber('dl', testData.dl)).toString();
    }

    testData.dlp = this._getDlp();

    if(additionalParams.dlp) {
      additionalParams.dlp = testData.dlp;
    }

    return encodeUriRecursive({
      sr: sCutData.sr,
      TestData: testData,
      AdditionalParams: additionalParams
    });
  }



}
